export default "__VITE_ASSET__0_sRn0BA__"